<template>
  <div class="footer">

    <!-- <div class="describle">
      <p>{{ $t('home.p40') }}</p>
      <i18n class="p-content" path="home.p41" tag="p">
        <a class="primary_color" style="box-shadow: 0 1px;" place="link" target="_blank" href="/mobile/restricted_territory">{{ $t('home.p53') }} </a>
      </i18n>
      <p>{{ $t('home.p42') }}</p>
      <p>{{ $t('home.p43') }} {{ $t('home.p44') }}</p>
    </div>

    <div class="divide-line"></div>

    <div class="follow" v-if="!hidedata">
      <p class="title">{{ $t('home.p52') }}</p>
      <div>
        <a target="_blank" href="https://www.facebook.com/kkpokerglobal/?utm_source=KKpokerwebsite&utm_medium=websiteFB&utm_campaign=KKpokerwebsite">
          <img class="facebook-img" src="/mobile/static/img/home/icon_03.png" />
        </a>
        <a target="_blank" href="https://www.instagram.com/kkpokerglobal/?utm_source=KKpokerwebsite&utm_medium=websiteIG&utm_campaign=KKpokerwebsite">
          <img class="ins-img" src="/mobile/static/img/home/icon_04.png" />
        </a>
        <a target="_blank" href="https://twitter.com/kkpokerglobal?utm_source=KKpokerwebsite&utm_medium=websitetwitter&utm_campaign=KKpokerwebsite">
          <img class="twitter-img" src="/mobile/static/img/home/icon_05.png" />
        </a>
      </div>
    </div>

    <div class="divide-line"></div> -->

    <div class="jump_btn">
      <a><img class="icon_06" src="/mobile/static/img/home/icon_06.png" /></a>
      <a target="_blank" href="https://access.gaminglabs.com/Certificate/Index?i=372"><img class="icon_07" src="/mobile/static/img/home/icon_07.png?t=20220401" /></a>
      <a><img class="icon_08" src="/mobile/static/img/home/icon_08.png" /></a>
      <a><img class="icon_09" src="/mobile/static/img/home/icon_09.png" /></a>
      <a><img class="icon_10" src="/mobile/static/img/home/icon_10.png" /></a>
    </div>

    <!-- <div class="divide-line"></div> -->

    <!-- <div class="content" v-if="!hidedata">
      <a href="/mobile/about">{{ $t('home.p45') }}</a>
      <br/>
      <a href="/mobile/PrivacyPolicy">{{ $t('home.p46') }}</a>
      <br/>
      <a href="/mobile/TermsOfService">{{ $t('home.p47') }}</a>
    </div>
    <div class="content" v-if="hidedata"></div> -->

    <!-- <div class="copyright">
      <p>{{ $t('home.p48') }}</p>
    </div> -->
  </div>
</template>

<script>
// @ is an alias to /src
// import { receiveUserEmail } from '@/api/official'
// import Cookies from 'js-cookie'

export default {
  data () {
    return {
      input: '',
      show: false,
      FB_VERSON: '',
      checked: false,
      subscribe_error: '',
      subscribe_step: 0
    }
  },
  props: ['hidedata'],
  methods: {
    toBottom () {
      if (
        navigator.userAgent.indexOf('Android') > -1 ||
        navigator.userAgent.indexOf('Adr') > -1
      ) {
        document.querySelector('.footer').scrollIntoView(true)
      }
    },
    toBury (key, f1, f2, f3, f4, f5) {
      this.$axios.get(
        'https://client-click.cn-hongkong.log.aliyuncs.com/logstores/client-logstroe/track',
        {
          params: {
            APIVersion: '0.6.0',
            __topic__: key,
            f1,
            f2,
            f3,
            f4,
            f5,
            log_type: 10001
          }
        }
      )
    }
  },
  created () {
    // this.FB_VERSON = FB_VERSON
  },
  mounted () {
    // setTimeout(() => {
    //   let subscribe =  Cookies.get('subscribe')
    //   if(!subscribe) {
    //     this.show = true
    //     this.subscribe_step = 1
    //   }
    // }, 30000)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.footer {
  position: relative;
  font-size: 24px;
  color: #fff;
  // background-color: #151515;
  padding: 0px 40px;
  .describle {
    p {
      font-size: 20px;
      color: #e7e7e7;
      line-height: 36px;
      margin-bottom: 16px;
      font-weight: 100;
      a {
        font-size: 20px;
        line-height: 36px;
      }
    }
    margin-bottom: 40px;
  }
  .divide-line {
    width: 100%;
    height: 1PX;
    background-color: #444444;
  }
  .follow {
    padding: 34px 0px;
    .title {
      margin-bottom: 20px;
      color: #8a8a8a;
      font-size: 18px;
    }
    img {
      display: inline-block;
    }
    a {
      display: inline-block;
      margin-right: 48px;
      vertical-align: middle;
    }
    .facebook-img {
      width: 24px;
    }
    .ins-img {
      width: 38px;
    }
    .twitter-img {
      width: 47px;
    }
  }
  .jump_btn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 50px 0px 40px 0px;
    text-align: center;
    a {
      display: inline-block;
      margin: 0px 10px 25px 10px ;
      cursor: pointer;
    }
    img {
      display: inline-block;
      vertical-align: middle;
      // margin: 0px 16px;
    }
    .icon_06 {
      width: 76px;
    }
    .icon_07 {
      width: 97px;
    }
    .icon_08 {
      width: 89px;
    }
    .icon_09 {
      width: 165px;
    }
    .icon_10 {
      width: 48px;
    }
  }

  .content {
    padding: 20px 0px;
    display: inline-block;
    margin-right: 100px;
    a {
      color: #ffffff;
      font-size: 24px;
      margin: 10px 0px;
      display: inline-block;
      // box-shadow: 0 1PX;
    }
  }
  .copyright p {
    color: #8a8a8a;
    font-size: 18px;
  }
}
</style>
